import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Configure16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.25 3.1875C7.25 2.51189 7.80731 2 8.45 2H12.05C12.6927 2 13.25 2.51189 13.25 3.1875V3.75L16 3.75V5.25L13.25 5.25V5.8125C13.25 6.48811 12.6927 7 12.05 7H8.45C7.80731 7 7.25 6.48811 7.25 5.8125V5.25H0V3.75H7.25V3.1875ZM8.75 3.5V5.5H11.75V3.5H8.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.75 10.75V10.1875C2.75 9.51189 3.30732 9 3.95 9L7.55 9C8.19269 9 8.75 9.51189 8.75 10.1875V10.75L16 10.75V12.25L8.75 12.25V12.8125C8.75 13.4881 8.19269 14 7.55 14H3.95C3.30732 14 2.75 13.4881 2.75 12.8125V12.25L0 12.25V10.75L2.75 10.75ZM7.25 10.5L7.25 12.5H4.25L4.25 10.5H7.25Z'
      fill='currentColor'
    />
  </Svg>
);

Configure16.displayName = 'Configure16';
export default Configure16;
